import { IConditionFlow } from '@/interface';

import { getNodeId } from './getNodeId';
import { IStoryLineData } from './getStoryLineNodesEdges';

const transformCondition = (postData: any, index: number, sceneId: string) => {
  const condition: IConditionFlow = {
    id: postData.condId || `condition_${getNodeId(index)}`,
    conditionNodeId: '',
    sceneId,
    rootId: '',
    type: postData.passCondType,
    missions: postData.specifyMission?.missions?.map((m: any) => ({
      id: m.missionId,
      name: m.missionName,
    })),
    openTrigger: !!postData.triggerTrap?.specifyNumeric?.isUsed,
    openCount: !!postData.triggerTrap?.countDown,
    triggerValue: {
      minV: postData.triggerTrap?.specifyNumeric?.minVal,
      maxV: postData.triggerTrap?.specifyNumeric?.maxVal,
    },
    countDown: postData.triggerTrap?.countDown,
    triggerMissionId: postData.triggerMissionId,
    nextSceneId: postData.nextSceneId,
  };
  return condition;
};

export const exclStoryLine = (data: any) => {
  const storyLineData: IStoryLineData = {
    createdBy: data?.createdBy,
    storyName: data?.storyName,
    status: data?.auditStatus,
    publishedAt: data?.publishedAt,
    multiStoryLine: data?.multiStoryLine?.map((storyLine: any) => ({
      layeredSceneNodes: storyLine.layeredSceneNodes?.map((layeredScene: any) => ({
        sceneNodes: layeredScene?.sceneNodes?.map((scene: any) => ({
          ...scene,
          passConds: scene?.passConds?.map((condition: any, index: number) => ({
            ...transformCondition(condition, index, scene?.sceneId),
          })) || [],
        })) || [],
      })) || [],
    })) || [],
  };
  return storyLineData;
};
